export const colors = {
  orange: 'rgb(255,69,0)',
  darkblue: '#003246',
  lightblue: '#0387B1',
  white: 'rgb(245,245,245)',
  gray: 'rgb(180,180,180)',
  alphaBlack: 'rgba(0, 0, 0, 0.6)',
};
